import { Brick, registerBrick, tagToString } from 'olympe';

export default class CheckIfInspectionIsDisabled extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Object<Map<string, Observation>>} data
     * @param {Unit} unit
     * @param {Inspection} inspection
     * @param {function(boolean)} setDisabled
     */
    update($, [data, unit, inspection], [setDisabled]) {
        const observations = data[tagToString(unit)];
        const isInResult = observations?.has(inspection.getTag()) ?? false;
        setDisabled(isInResult);
    }
}

registerBrick('018b18e8bcc181ba7f96', CheckIfInspectionIsDisabled);
